import React, { Component } from 'react';

import './aboutstyles.css'

class About extends Component {
  componentDidMount(){
  }
  render() {
    return (
      <div>
        <div className='container about-us-section'>
          <h2 className="section-main-title section-heading-krypton">
            ABOUT US
          </h2>
          <hr></hr>
          <p className="descriptionText">
            33 Capital consists of a group of global financial services businesses specialising in 
            startup advisory and principal investments with partner offices in Singapore, Hong Kong, 
            Thailand and Cambodia. We are investors who provide capital, expertise and support our 
            portfolio companies to reach their full potential and create possibilities. 
            We believe great investments and results come from meaningful collaboration with our 
            partners and companies in which we invest.
          </p>
        </div>
        <div id="dt_row_20" className="clearfix dt_row dt_row_20" data-speed="2" data-type="background">
          <div className="container">
            <div className="row">
              <div id="dt_column_21" className="dt_column col-sm-12">
                <div id="dt_row_22153724923691" className="row dt_row">
                  <div id="dt_column_23" className="dt_column col-sm-12">
                    <div id="dt_text24153724923621" className="dt_text"><br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr></hr>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About/index.js